var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (equipment, gems, itemGroups, me, selectedHero, selectedHeroClass) {pug_html = pug_html + "\u003Cdiv class=\"modal-dialog\"\u003E\u003Cdiv class=\"modal-content\"\u003E\u003Cimg src=\"\u002Fimages\u002Fpages\u002Fplay\u002Fmodal\u002Finventory-background.png\" draggable=\"false\" id=\"play-items-modal-narrow-bg\"\u003E\u003Ch1 data-i18n=\"game_menu.inventory_tab\"\u003E\u003C\u002Fh1\u003E\u003Cdiv id=\"gems-count-container\"\u003E\u003Cspan class=\"big-font\" id=\"gems-count\"\u003E" + (pug.escape(null == (pug_interp = gems) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"close-modal\"\u003E\u003Cspan class=\"glyphicon glyphicon-remove\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"equipped\"\u003E";
if (selectedHero && selectedHero.get('featureImages')) {
var featureImages = selectedHero.get('featureImages');
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", "/file/"+featureImages.body, true, true)+" draggable=\"false\" id=\"hero-image\"") + "\u003E\u003Cimg" + (pug.attr("src", "/file/"+featureImages.head, true, true)+" draggable=\"false\" id=\"hero-image-head\"") + "\u003E\u003Cimg" + (pug.attr("src", "/file/"+featureImages.hair, true, true)+" draggable=\"false\" id=\"hero-image-hair\"") + "\u003E\u003Cimg" + (pug.attr("src", "/file/"+featureImages.thumb, true, true)+" draggable=\"false\" id=\"hero-image-thumb\"") + "\u003E";
}
// iterate ['head', 'eyes', 'neck', 'torso', 'gloves', 'wrists', 'left-hand', 'right-hand', 'waist', 'feet', 'left-ring', 'right-ring', 'minion', 'flag', 'pet', 'programming-book', 'misc-0', 'misc-1']
;(function(){
  var $$obj = ['head', 'eyes', 'neck', 'torso', 'gloves', 'wrists', 'left-hand', 'right-hand', 'waist', 'feet', 'left-ring', 'right-ring', 'minion', 'flag', 'pet', 'programming-book', 'misc-0', 'misc-1'];
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var slot = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"item-slot\""+pug.attr("data-slot", slot, true, true)) + "\u003E\u003Cdiv class=\"placeholder\"\u003E\u003C\u002Fdiv\u003E";
if (equipment[slot]) {
pug_html = pug_html + "\u003Cimg" + (" class=\"item\""+pug.attr("src", equipment[slot].getPortraitURL(), true, true)+pug.attr("data-item-id", equipment[slot].id, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var slot = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"item-slot\""+pug.attr("data-slot", slot, true, true)) + "\u003E\u003Cdiv class=\"placeholder\"\u003E\u003C\u002Fdiv\u003E";
if (equipment[slot]) {
pug_html = pug_html + "\u003Cimg" + (" class=\"item\""+pug.attr("src", equipment[slot].getPortraitURL(), true, true)+pug.attr("data-item-id", equipment[slot].id, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv id=\"unequipped\"\u003E\u003Cdiv class=\"nano\"\u003E\u003Cdiv class=\"nano-content\"\u003E";
if (itemGroups) {
if (itemGroups.requiredPurchaseItems.models.length) {
pug_html = pug_html + "\u003Ch4 id=\"required-purchase-description\" data-i18n=\"inventory.required_purchase_title\"\u003E\u003C\u002Fh4\u003E";
// iterate itemGroups.requiredPurchaseItems.models
;(function(){
  var $$obj = itemGroups.requiredPurchaseItems.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var item = $$obj[pug_index1];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var item = $$obj[pug_index1];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
}
if (itemGroups.availableItems.models.length) {
pug_html = pug_html + "\u003Ch4 id=\"available-description\" data-i18n=\"inventory.available_item\"\u003E\u003C\u002Fh4\u003E";
// iterate itemGroups.availableItems.models
;(function(){
  var $$obj = itemGroups.availableItems.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var item = $$obj[pug_index2];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item","available",item.classes], [false,false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg\u003E\u003Cbutton class=\"btn equip-item\" data-i18n=\"inventory.equip\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var item = $$obj[pug_index2];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item","available",item.classes], [false,false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg\u003E\u003Cbutton class=\"btn equip-item\" data-i18n=\"inventory.equip\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"alert alert-info\" id=\"double-click-hint\"\u003E\u003Cspan class=\"glyphicon glyphicon-info-sign spr\"\u003E\u003C\u002Fspan\u003E\u003Cspan data-i18n=\"inventory.should_equip\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
if (itemGroups.subscriberItems.models.length && !me.freeOnly() && !me.isInHourOfCode()) {
pug_html = pug_html + "\u003Ch4 id=\"restricted-description\"\u003ESubscriber Only\u003C\u002Fh4\u003E";
// iterate itemGroups.subscriberItems.models
;(function(){
  var $$obj = itemGroups.subscriberItems.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var item = $$obj[pug_index3];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var item = $$obj[pug_index3];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
}
if (itemGroups.restrictedItems.models.length) {
pug_html = pug_html + "\u003Ch4 id=\"restricted-description\" data-i18n=\"inventory.restricted_title\"\u003E\u003C\u002Fh4\u003E";
// iterate itemGroups.restrictedItems.models
;(function(){
  var $$obj = itemGroups.restrictedItems.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var item = $$obj[pug_index4];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var item = $$obj[pug_index4];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
}
if (itemGroups.lockedItems.models.length) {
pug_html = pug_html + "\u003Ch4 id=\"locked-description\" data-i18n=\"play.locked\"\u003E\u003C\u002Fh4\u003E";
// iterate itemGroups.lockedItems.models
;(function(){
  var $$obj = itemGroups.lockedItems.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var item = $$obj[pug_index5];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var item = $$obj[pug_index5];
if (selectedHeroClass && item.classes.indexOf(selectedHeroClass) > -1) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["item",item.classes], [false,true]), false, true)+pug.attr("data-item-id", item.id, true, true)) + "\u003E\u003Cimg draggable=\"false\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"item-details-view\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"item-details-extra\"\u003E\u003Cbutton class=\"btn secret\" id=\"equip-item-viewed\" data-i18n=\"inventory.equip\"\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn secret\" id=\"unequip-item-viewed\" data-i18n=\"inventory.unequip\"\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn big-font secret\" id=\"subscriber-item-viewed\" data-i18n=\"play.subscribe_unlock\"\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"alert alert-danger secret\" id=\"restricted-item-viewed\" data-i18n=\"inventory.restricted\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (!me.isStudent()) {
pug_html = pug_html + "\u003Cbutton class=\"btn btn-lg btn-primary choose-inventory-active\" id=\"choose-hero-button\" data-i18n=\"play.change_hero_or_language\"\u003E\u003C\u002Fbutton\u003E";
}
else
if (me.showHeroAndInventoryModalsToStudents()) {
pug_html = pug_html + "\u003Cbutton class=\"btn btn-lg btn-primary choose-inventory-active\" id=\"choose-hero-button\" data-i18n=\"play.change_hero\"\u003E\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003Cbutton class=\"btn btn-lg btn-success choose-inventory-active\" id=\"play-level-button\" data-i18n=\"common.play\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"equipment" in locals_for_with?locals_for_with.equipment:typeof equipment!=="undefined"?equipment:undefined,"gems" in locals_for_with?locals_for_with.gems:typeof gems!=="undefined"?gems:undefined,"itemGroups" in locals_for_with?locals_for_with.itemGroups:typeof itemGroups!=="undefined"?itemGroups:undefined,"me" in locals_for_with?locals_for_with.me:typeof me!=="undefined"?me:undefined,"selectedHero" in locals_for_with?locals_for_with.selectedHero:typeof selectedHero!=="undefined"?selectedHero:undefined,"selectedHeroClass" in locals_for_with?locals_for_with.selectedHeroClass:typeof selectedHeroClass!=="undefined"?selectedHeroClass:undefined));;return pug_html;};
module.exports = template;